import clsx from "clsx";
import styles from "./TableLabels.module.scss";
import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import { CaretUpDownIcon } from "@/frontend/shared/assets/icons";
import { headers } from "../const/const";

type TTableLabels = {
  className?: string;
};

export function TableLabels({ className }: TTableLabels) {
  return (
    <div className={clsx(styles.container, className)}>
      {headers.map((item, index) => (
        <div key={index} className={clsx(item.key === "name" ? styles.checkboxContainer : styles.labelContainer)}>
          <Typography
            className={clsx(styles.label)}
            variant={item.key === "name" ? undefined : "label-4"}
            color={item.key === "name" ? undefined : "greyscale600"}
          >
            {item.label}
          </Typography>
        </div>
      ))}
    </div>
  );
}
